export function deelVeilig(teller: number, noemer: number): number {
  return noemer !== 0 ? teller / noemer : 0;
}
